import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ApiService } from '../../../../services/api.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule],
  templateUrl: './layout.html',
  styleUrl: './layout.css',
})
export class Layout implements OnInit {

  user?: { picture?: string; name?: string; ownerName?: string; };
  userName: string = '';
  selectedContact: any = null;

  // ── Dialog state ──────────────────────────────────────
  showSwitchDialog = false;
  switchStep: 'logout-confirm' | 'send-otp-confirm' | 'otp' | 'accounts' = 'logout-confirm';

  // OTP
  otpDigits: string[] = ['', '', '', '', '', ''];
  otpLoading = false;
  otpError = '';
  resendCooldown = 0;
  private cooldownTimer: any;

  // Accounts
  accounts: any[] = [];
  selectedAccount: any = null;
  accountsLoading = false;

  beneficiaryEmail: string = '';

  get hasMultipleAccounts(): boolean {
    try {
      const list = JSON.parse(localStorage.getItem('beneficiaryList') || '[]');
      return list.length > 1;
    } catch { return false; }
  }

  constructor(
    private router: Router,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const beneficiaryId =
  localStorage.getItem('beneficiaryId');

console.log(
  'Loading checklist for:',
  beneficiaryId
);

  const selected = localStorage.getItem('selectedBeneficiary');

  if (selected) {
    this.user = JSON.parse(selected);
    this.userName = this.user?.name || this.user?.ownerName || '';
  }

  // Get beneficiary email/identifier
  

this.beneficiaryEmail =
  localStorage.getItem('beneficiary_login_email') || '';

console.log(
  'Switch Account Email =>',
  this.beneficiaryEmail
);

}

  getFirstName(): string {
    return this.user?.name?.split(' ')[0] || this.userName || 'User';
  }

  // ── Open / close ──────────────────────────────────────

 openSwitchDialog(): void {

  this.beneficiaryEmail =
    localStorage.getItem('beneficiary_login_email') || '';

  console.log('Switch Email:', this.beneficiaryEmail);

  this.switchStep = 'logout-confirm';
  this.otpDigits = ['', '', '', '', '', ''];
  this.otpError = '';
  this.showSwitchDialog = true;
}

  closeSwitchDialog(): void {
    this.showSwitchDialog = false;
    clearInterval(this.cooldownTimer);
    this.resendCooldown = 0;
    this.otpError = '';
    this.otpLoading = false;
  }

  // ── STEP 1: OK clicked → logout API → move to send-otp-confirm ──

  confirmLogout(): void {
    this.otpLoading = true;
    this.otpError = '';
     this.beneficiaryEmail =
    localStorage.getItem('beneficiary_login_email') || '';

  console.log('Email before logout:', this.beneficiaryEmail);

  this.otpLoading = true;
  this.otpError = '';

    this.apiService.logoutBeneficiary().subscribe({
      next: () => {
        // Clear session data after successful logout
        localStorage.removeItem('beneficiary_token');
        localStorage.removeItem('selected_account');
        localStorage.removeItem('selectedBeneficiary');
        this.otpLoading = false;
        this.switchStep = 'otp';
        
        this.sendOtp();
      },
      error: () => {
        // Even if logout API fails, proceed — session may already be invalid
        localStorage.removeItem('beneficiary_token');
        localStorage.removeItem('selected_account');
        localStorage.removeItem('selectedBeneficiary');
        this.otpLoading = false;
        this.switchStep = 'send-otp-confirm';
      }
    });
  }

  // ── STEP 2: Send OTP → sendBeneficiaryOtp API ────────

 sendOtp(): void {

  console.log('Identifier sent to API =>', this.beneficiaryEmail);

const email =
  localStorage.getItem('beneficiary_login_email') || '';

if (!email) {
  this.otpError = 'Email not found.';
  return;
}
  this.otpLoading = true;
  this.otpError = '';

  this.apiService
    .sendBeneficiaryOtp(email)
    .subscribe({
      next: (res) => {

        console.log('OTP Sent Successfully', res);

        this.otpLoading = false;
        this.switchStep = 'otp';
        this.otpDigits = ['', '', '', '', '', ''];

        this.cdr.detectChanges();

        this.startResendCooldown();

        setTimeout(() => {
          (
            document.getElementById('sw-otp-0') as HTMLInputElement
          )?.focus();
        }, 200);
      },
      error: (err) => {

        console.error('OTP API Error =>', err);

        this.otpLoading = false;

        this.otpError =
          err?.error?.detail ||
          err?.error?.message ||
          'Unable to send OTP. Please try again.';
      }
    });
}

  // ── STEP 3: Verify OTP → verifyBeneficiaryOtp API ────

  verifyOtp(): void {
    const otp = this.otpDigits.join('');
    if (otp.length < 6) {
      this.otpError = 'Please enter the complete 6-digit OTP.';
      return;
    }
    this.otpLoading = true;
    this.otpError = '';

    const email =
  localStorage.getItem('beneficiary_login_email') || '';

this.apiService.verifyBeneficiaryOtp(
  email,
  otp
).subscribe({
      next: (res: any) => {
        // Store new session token
        if (res.session_token) {
          localStorage.setItem('beneficiary_token', res.session_token);
        }
        if (res.user) {
          localStorage.setItem('beneficiary_user', JSON.stringify(res.user));
        }
        // Now load accounts list
        this.loadAccountList();
      },
      error: (err: any) => {
        this.otpLoading = false;
        this.otpError = err.error?.message || 'Invalid OTP. Please try again.';
      }
    });
  }

  // ── STEP 4: Load accounts → getBeneficiaryList API ───

  loadAccountList(): void {
    this.accountsLoading = true;

    this.apiService.getBeneficiaryList().subscribe({
      next: (list: any) => {
        localStorage.setItem('beneficiaryList', JSON.stringify(list));
        this.accounts = (list || []).map((item: any, i: number) => ({
          id: i + 1,
          ownerName: item.ownerName || item.name,
          beneficiaryId: item.beneficiaryId,
          raw: item
        }));
        this.selectedAccount = null;
        this.otpLoading = false;
        this.accountsLoading = false;
        this.switchStep = 'accounts';
        this.cdr.detectChanges();
      },
      error: () => {
        this.otpLoading = false;
        this.accountsLoading = false;
        this.otpError = 'Failed to load accounts. Please try again.';
      }
    });
  }

  // ── STEP 5: Select account → selectBeneficiary API ───

  selectAccount(account: any): void {
    this.selectedAccount = account;

    this.apiService.selectBeneficiary(account.beneficiaryId).subscribe({
     next: (res: any) => {

  localStorage.setItem(
    'beneficiaryId',
    String(account.beneficiaryId)
  );

  localStorage.setItem(
    'selected_account',
    JSON.stringify(account)
  );

  const raw = localStorage.getItem('beneficiaryList');
  const list = JSON.parse(raw || '[]');

  const matched = list.find(
    (item: any) =>
      item.beneficiaryId === account.beneficiaryId
  );

  localStorage.setItem(
    'selectedBeneficiary',
    JSON.stringify(matched || account.raw)
  );

  this.user = matched || account.raw;

  this.userName =
    this.user?.name ||
    this.user?.ownerName ||
    '';

this.closeSwitchDialog();

this.router.navigateByUrl('/', {
  skipLocationChange: true
}).then(() => {
  this.router.navigate([
    '/beneficiary-layout/checklist'
  ]);
});
},
      error: () => {
        this.otpError = 'Failed to switch account. Please try again.';
        this.selectedAccount = null;
      }
      
    });
  }

  // ── OTP input handlers ────────────────────────────────

  onOtpInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const val = input.value.replace(/\D/g, '');
    this.otpDigits[index] = val ? val[val.length - 1] : '';
    if (val && index < 5) {
      (document.getElementById('sw-otp-' + (index + 1)) as HTMLInputElement)?.focus();
    }
  }

  onOtpKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
      (document.getElementById('sw-otp-' + (index - 1)) as HTMLInputElement)?.focus();
    }
  }

  onOtpPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const text = event.clipboardData?.getData('text') || '';
    const digits = text.replace(/\D/g, '').slice(0, 6).split('');
    digits.forEach((d, i) => { this.otpDigits[i] = d; });
    const last = Math.min(digits.length, 5);
    (document.getElementById('sw-otp-' + last) as HTMLInputElement)?.focus();
  }

  private startResendCooldown(): void {
    clearInterval(this.cooldownTimer);
    this.resendCooldown = 30;
    this.cooldownTimer = setInterval(() => {
      this.resendCooldown--;
      if (this.resendCooldown <= 0) clearInterval(this.cooldownTimer);
    }, 1000);
  }

  // ── Full logout (header button) ───────────────────────

  logout(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.apiService.logoutBeneficiary().subscribe({
      next: () => this.router.navigate(['/login'], { replaceUrl: true }),
      error: () => this.router.navigate(['/login'], { replaceUrl: true })
    });
  }

  openProfile(): void { this.router.navigate(['/login']); }
  closeProfile(): void {}
}